import FuseAnimate from '@/@fuse/core/FuseAnimate';
import FusePageSimple from '@/@fuse/core/FusePageSimple';
import { makeStyles } from '@material-ui/core/styles';
import { useRef } from 'react';
// import ChildReminder from './Childremainder';
import EventsSidebar from './EventsSideBar';
import LoggedActivities from './LoggedActivities/LoggedActivities';
import MessageListing from './MessageListing';
import RoomRatios from './RoomRatios/RoomRatios';
import './SubAdminDashboard.css';
import UpcomingBirthdays from './UpcomingBirthday';
import BillingWidget from './BillingWidget';

const useStyles = makeStyles({
	layoutRoot: {},
	sidebar: {
		width: 320,
	},
});

const SubAdminDashboard = () => {
	const classes = useStyles();
	const pageLayout = useRef(null);

	return (
		<FusePageSimple
			classes={{
				root: classes.layoutRoot,
				sidebar: classes.sidebar,
			}}
			content={
				<div className="px-24 xl:px-64 py-68 mb-64  max-w-4xl mx-auto">
					<FuseAnimate animation="transition.slideLeftIn" duration={600}>
						<div className="">
							<div className="flex flex-col gap-32">
								<BillingWidget />
								<div className="grid grid-cols-1 md:grid-cols-2 gap-32 md:gap-20">
									<MessageListing />

									<RoomRatios />
								</div>
								{/* TODO: Re-enable child reminders section once we complete updated immunization efforts */}
								{/* <ChildReminder /> */}
								<LoggedActivities />
							</div>
						</div>
					</FuseAnimate>
				</div>
			}
			innerScroll
			ref={pageLayout}
			rightSidebarContent={
				<div className="home-sidebar">
					<EventsSidebar />
					<UpcomingBirthdays />
				</div>
			}
		/>
	);
};

export default SubAdminDashboard;
